import { HttpStatusCode } from 'axios';
import { ApiRequest } from '../../Handlers/ApiReqest';
import { Notify } from '../../Handlers/Notifications';
import { clientsSheetItem, printingClientsSheetItem } from '../../Models/Trainee';
import { InterActive } from '../../utilities/ViewModelStructure'
import * as XLSX from 'xlsx';

export class ClientsSheetVM extends InterActive{
    private data:clientsSheetItem[] = [];
    public get Data():clientsSheetItem[]{ return this.data  }
    public set Data(value:clientsSheetItem[]){ this.data = value ; this.update()  }

    private search:string = '';
    public get Search():string{ return this.search  }
    public set Search(value:string){ this.search = value ; this.update()  }

    private from:string = '';
    public get From():string{ return this.from  }
    public set From(value:string){ this.from = value ; this.update()  }

    private to:string = '';
    public get To():string{ return this.to  }
    public set To(value:string){ this.to = value ; this.update()  }

    public getData(){
        this.loading(
            async()=>{
                if(this.val()){
                    try{
                        const response = await ApiRequest.clientsSheet({search:this.search , from:this.from , to:this.to})
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    this.data = response.data.data
                                    this.update()
                                }else Notify({type:'danger' , title:'فشل عملية الازالة', body:response.data.messege})
                            }else Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                        }
                    }catch{
                        Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }
            }
        )
    }

    public val(){
        if(!this.from){  return false }
        if(!this.to){  return false }
        return true
    }

    public downloadExcel()  {
        const worksheet = XLSX.utils.json_to_sheet(
            this.data.map(item=>({
                'م':item.id,
                'الاسم العربي':item.arabic_name,
                'الاسم الانجليزي':item.english_name,
                'الايميل':item.email,
                'رقم الموبايل':'+'+item.dial_code+' '+item.mobile,
                'رقم الهوية':item.national_id,
                'الجنسية':item.nationality,
                'تاريخ الميلاد':item.birth_date,
                'العنوان':item.address,
                'النوع':item.is_male?'ذكر':'انثى',
                'المسوق':item.marketer_name,
                'الاشتراكات':item.subscriptions,
                'المدفوعات':item.total_paid
            }))
        )
        const workbook = XLSX.utils.book_new()

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook,  'clients_from_'+this.from+'_to_'+this.to+'.xlsx');
      };
}